<template>
<div class="chapter">
<div class="inner_page">
<h1 class="titlea">AN</h1>
<h1 class="title">ASSISTANT<br/>PROFESSOR</h1>
<p class="title1">A NOVEL OF SORTS</p>
<p class="title2">ADEEB YUSEF SALAM</p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
<p class="pub">New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?20f54a33